/**
 *  Arquivo responsável por guardar o estado do componente
 *          de turmas para matricula
 */
export default {
    enrollmentPeriod: {},    
    selectedClassesEnrollment: [],
    candidate: {}
}